<template>
  <PSkeleton
    class="s-input-skeleton"
    :class="`s-input-skeleton--size-${size}`"
  />
</template>

<script setup lang="ts">
import PSkeleton from "@/atoms/PSkeleton.vue";

/* Can be used for all basic input atoms with the same layout
 * autocomplete
 * datepicker
 * email
 * number input
 * password
 * select
 * text input
 * tree select
 */
withDefaults(defineProps<{ size?: "lg" | "md" | "sm" }>(), {
  size: "md",
});
</script>

<style lang="postcss">
.s-input-skeleton {
  &--size {
    &-lg {
      @apply min-h-14;
    }

    &-md {
      @apply min-h-12;
    }

    &-sm {
      @apply min-h-10;
    }
  }
}
</style>
